module.exports = __webpack_public_path__ + "img/calculator_white.0d56fd11.png";